import { Participant } from "./participant";
import { SessionTypes, ParticipantTypes } from "./types";

const VIDEO_FREEZE_THRESHOLD_MS = 20000;  // if video is frozen for this long, disconnect

export class VideoDeviceParticipant extends Participant {
  /**
   * 
   * @param {string} peerId - the id of the peer
   * @param {RTCPeerConnection} rtcPeerConnection - the RTCPeerConnection object 
   * @param {ConnectionContext} context - the connection context
   * @param {int} videoDeviceId - the id of the video device
   */
  constructor({ peerId, rtcPeerConnection, context, videoDeviceId, dataChannelMessageListener }) {
    super({ peerId, rtcPeerConnection, context, participantType: ParticipantTypes.device, dataChannelMessageListener });
    this.videoDeviceId = videoDeviceId;  // numeric API id of the video device
    this.videoFrozenAt = null;  // timestamp of when the video was frozen
  }

  async connectLocalMedia() {
    const localMediaStream = this.context.localMediaStream;
    if (localMediaStream) {
      console.debug("local media stream available", localMediaStream);
      // the stream may have video but that is separately sent to a kiosk connection
      localMediaStream.getAudioTracks().forEach((track) => {
        // console.debug(`adding track ${track.kind} to device ${this.videoDeviceId}`, track);
        if (this.context.sessionType === SessionTypes.monitoring) {
          track.enabled = false;  // disable audio for monitoring
          console.debug(`disabling audio track ${track.kind} for monitoring`, track);
        }
        // this.rtcPeerConnection.addTrack(track, localMediaStream);
        // this.rtcPeerConnection.addTrack(track, localMediaStream);
        super.addLocalMediaTrack(track, localMediaStream);
      });
    } else if (this.context.sessionType !== SessionTypes.test) {
      console.error("no local media stream available");
      this.emit("error", "no-local-media-stream");
    }
  }

  configurePeerConnectionListeners() {
    super.configurePeerConnectionListeners();
    const peerConn = this.rtcPeerConnection;

    // special handling for video device (patient) connections
    peerConn.addEventListener("track", (event) => {
      event.track.onmute = (event) => {
        console.warn(`device ${this.videoDeviceId} video track for ${this.peerId} was muted/frozen`, event);
        this.videoFrozenAt = Date.now();
        setTimeout(() => {
          console.debug(`checking if video is still frozen... ${this.videoFrozenAt}`);
          if (this.videoFrozenAt && Date.now() - this.videoFrozenAt >= (VIDEO_FREEZE_THRESHOLD_MS - 250)) {
            console.warn(`device ${this.videoDeviceId} video track for ${this.peerId} is still frozen - disconnecting`);
            this.emit("error", "patient-video-frozen");
          } else if (this.videoFrozenAt) {
            console.info(`patient ${this.videoDeviceId} video track for ${this.peerId} is still frozen - assuming another check is coming`)
          } else {
            console.info(`patient ${this.videoDeviceId} video track for ${this.peerId} is no longer frozen`);
          }
        }, VIDEO_FREEZE_THRESHOLD_MS);
      }
      event.track.onunmute = (event) => {
        console.info(`patient ${this.videoDeviceId} video track for ${this.peerId} was unmuted`, event);
        this.videoFrozenAt = null;
      }
    })

    console.debug(`video device ${this.videoDeviceId} peer connection listeners configured`);
  }
}